import { QueryClient } from '@tanstack/react-query'
import { isClientError } from './errors'

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      gcTime: 5 * 60_000,
      // Retrying a 4xx just repeats the same mistake.
      retry: (failureCount, error) => failureCount < 2 && !isClientError(error),
      // Alt-tabbing back mid-thought must not reshuffle a board under the cursor.
      refetchOnWindowFocus: false,
      throwOnError: false,
    },
    mutations: {
      // A retried card move would fight the optimistic patch and the 409 handling.
      retry: 0,
    },
  },
})
